import { axiosInstance } from "../axios/axiosInstance";

const WIDGET_URL = process.env.REACT_APP_WESHUB_WIDGET_URL || "";
const WIDGET_SURFACE = process.env.REACT_APP_WESHUB_WIDGET_SURFACE || "website";
const WIDGET_HIDE_WHEN = process.env.REACT_APP_WESHUB_WIDGET_HIDE_WHEN || "";
const SCRIPT_FLAG = "data-weshub-widget";
const BOT_TOKEN_PATH = "chat/token";
const MIN_REFRESH_MS = 30000;

let mountId = 0;
let refreshTimer = null;

const widgetOrigin = () => {
  try {
    return new URL(WIDGET_URL, window.location.origin).origin;
  } catch (e) {
    return "";
  }
};

const widgetSrc = () => {
  try {
    const url = new URL(WIDGET_URL, window.location.origin);
    url.searchParams.set("v", Date.now());
    return url.toString();
  } catch (e) {
    return WIDGET_URL + (WIDGET_URL.includes("?") ? "&" : "?") + "v=" + Date.now();
  }
};

const removeWidgetNodes = () => {
  document.querySelectorAll(`script[${SCRIPT_FLAG}]`).forEach((node) => node.remove());

  const origin = widgetOrigin();
  const selectors = ['[id*="weshub" i]', '[class*="weshub" i]'];
  if (origin) selectors.push(`iframe[src^="${origin}"]`);

  document.querySelectorAll(selectors.join(",")).forEach((node) => {
    if (node.closest("#root")) return;
    node.remove();
  });
};

const clearRefresh = () => {
  clearTimeout(refreshTimer);
  refreshTimer = null;
};

const handOffBotToken = async (id) => {
  if (id !== mountId || typeof window.WesHub?.setToken !== "function") return;

  let delay = MIN_REFRESH_MS;
  try {
    const response = await axiosInstance.post(BOT_TOKEN_PATH, undefined, { skipSessionTimeout: true });
    const botToken = response?.data?.token;
    const renewIn = Number(response?.data?.renewIn);
    if (id !== mountId) return;
    if (botToken) {
      window.WesHub.setToken(botToken);
      if (!(renewIn > 0)) return;
      delay = Math.max(renewIn * 1000, MIN_REFRESH_MS);
    }
  } catch (e) {
    if (id !== mountId || e?.response?.status === 401) return;
  }

  refreshTimer = setTimeout(() => handOffBotToken(id), delay);
};

const teardownWidget = () => {
  mountId += 1;
  clearRefresh();
  removeWidgetNodes();
};

export const mountWeshubWidget = (token) => {
  if (!WIDGET_URL || typeof document === "undefined" || !token) return () => {};
  if (document.querySelector(`script[${SCRIPT_FLAG}]`)) return teardownWidget;

  mountId += 1;
  const id = mountId;

  const script = document.createElement("script");
  script.src = widgetSrc();
  script.async = true;
  script.setAttribute("data-surface", WIDGET_SURFACE);
  if (WIDGET_HIDE_WHEN) script.setAttribute("data-hide-when", WIDGET_HIDE_WHEN);
  script.setAttribute(SCRIPT_FLAG, "true");
  script.onload = () => handOffBotToken(id);
  document.head.appendChild(script);

  return teardownWidget;
};

export const unmountWeshubWidget = teardownWidget;
